//获取当前时间
const getDate = function(){
  let tempDate = new Date();
  
  let tempMonth = (tempDate.getMonth() + 1).toString().length > 1 ? tempDate.getMonth() + 1 : '0' + (tempDate.getMonth() + 1);
  let tempDay = tempDate.getDate().toString().length > 1 ? tempDate.getDate() : '0' + tempDate.getDate();
  let tempHours = tempDate.getHours().toString().length > 1 ? tempDate.getHours() : '0' + tempDate.getHours();
  let tempMinutes = tempDate.getMinutes().toString().length > 1 ? tempDate.getMinutes() : '0' + tempDate.getMinutes();
  
  return  `${tempDate.getFullYear()}-${tempMonth}-${tempDay} ${tempHours}:${tempMinutes}`
}

//获取当前时间
const getDateHour = function(date){
  let tempDate = new Date(date);
  
  let tempHours = tempDate.getHours().toString().length > 1 ? tempDate.getHours() : '0' + tempDate.getHours();
  let tempMinutes = tempDate.getMinutes().toString().length > 1 ? tempDate.getMinutes() : '0' + tempDate.getMinutes();
  
  return  `${tempHours}:${tempMinutes}`
}

const getDateSecond = function(date){
  let tempDate = new Date(date);
  
  let tempMonth = (tempDate.getMonth() + 1).toString().length > 1 ? tempDate.getMonth() + 1 : '0' + (tempDate.getMonth() + 1);
  let tempDay = tempDate.getDate().toString().length > 1 ? tempDate.getDate() : '0' + tempDate.getDate();
  let tempHours = tempDate.getHours().toString().length > 1 ? tempDate.getHours() : '0' + tempDate.getHours();
  let tempMinutes = tempDate.getMinutes().toString().length > 1 ? tempDate.getMinutes() : '0' + tempDate.getMinutes();
  let tempSecond = tempDate.getSeconds().toString().length > 1 ? tempDate.getSeconds() : '0' + tempDate.getSeconds();

  return  `${tempDate.getFullYear()}-${tempMonth}-${tempDay} ${tempHours}:${tempMinutes}:${tempSecond}`
}

const getDateDay = function(date){
  let tempDate = new Date(date);
  
  let tempMonth = (tempDate.getMonth() + 1).toString().length > 1 ? tempDate.getMonth() + 1 : '0' + (tempDate.getMonth() + 1);
  let tempDay = tempDate.getDate().toString().length > 1 ? tempDate.getDate() : '0' + tempDate.getDate();

  return  `${tempDate.getFullYear()}-${tempMonth}-${tempDay}`
}

export {
  getDate,
  getDateHour,
  getDateSecond,
  getDateDay,
}